import { Box } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

import { selectAppStatus } from '../../redux/reducers/appStatusReducer';
import { selectConversations } from '../../redux/reducers/conversationReducer';
import { ProjectWithLastScanned, ScopePagePair } from '../../Types/dealGPT';
import { ChatMode } from '../../Types/enums';
import ChatBubble from './ChatBubble';
import ChatInput from './ChatInput';
import SummaryIntroChatBubble from './SummaryIntroChatBubble';

interface IntellioAdvantageChatDrawerContentProps {
  vectorStoreId: string;
  project?: ProjectWithLastScanned;
  isDrawerChat?: boolean;
  activeTab?: ChatMode;
  collections?: string[];
  totalDocuments?: number;
  scopePagePairs?: ScopePagePair[];
  redirectOnProcess?: boolean;
  summaryFileIds?: string[];
}

const IntellioAdvantageChatDrawerContent: React.FC<IntellioAdvantageChatDrawerContentProps> = ({
  project,
  isDrawerChat,
  vectorStoreId,
  activeTab,
  collections = [],
  totalDocuments = 0,
  scopePagePairs = [],
  redirectOnProcess,
  summaryFileIds,
}) => {
  const { llm } = useSelector(selectAppStatus);
  const { currentMessages } = useSelector(selectConversations);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ flex: 1, overflowY: 'auto', p: 2 }}>
        <SummaryIntroChatBubble
          llm={llm}
          activeTab={activeTab}
          totalDocuments={totalDocuments}
          scopePagePairs={scopePagePairs}
          collections={collections}
        />
        {currentMessages.map((msg, index) => (
          <ChatBubble
            key={msg.id || `${msg.conversationId || 'no-convo'}-${index}`}
            llm={llm}
            message={msg}
            privateChat={false}
          />
        ))}
      </Box>
      <Box sx={{ p: 2, pr: 0, width: '100%' }}>
        <ChatInput
          project={project}
          hideWarnings={false}
          isDrawerChat={isDrawerChat}
          vectorStoreId={vectorStoreId}
          redirectOnProcess={redirectOnProcess}
          summaryFileIds={summaryFileIds}
        />
      </Box>
    </Box>
  );
};

export default IntellioAdvantageChatDrawerContent;
